<template>
  <v-checkbox
    v-set-test-id:input="['CheckboxField', testId || getModelExpression()]"
    v-bind="mergeProps($attrs, props, attrs)"
    :model-value="modelValue"
    @update:model-value="
      (v: boolean | unknown[] | null) => $emit('update:model-value', v)
    "
    @blur="onBlur"
  >
    <template v-for="(_, name) in slots" #[name]="slotData">
      <slot :name="name" v-bind="getSlotData(slotData)" />
    </template>
  </v-checkbox>
</template>

<script lang="ts" setup>
import { computed, mergeProps, useSlots } from 'vue';
import type { BaseValidation } from '@vuelidate/core';
import { VCheckbox } from 'vuetify/components/VCheckbox';
import type { ActionableComponentProps } from '@/common/components/ActionableComponent';
import {
  vSetTestId,
  getModelExpression,
} from '@/common/components/ActionableComponent';
import { getErrorMessage } from '@/common/components/form/FormField.vue';

// Get typed access to slots
const slots = useSlots();

// Wrap slotData to already be typed
type SlotData = Record<string, unknown>;
function getSlotData(data: unknown): SlotData {
  return (data ?? {}) as SlotData;
}

type Props = ActionableComponentProps & {
  modelValue?: boolean | unknown[];
  label?: string;
  validation?: BaseValidation;
};
const props = defineProps<Props>();
type Emits = {
  (e: 'update:model-value', v: boolean | unknown[] | null): void;
  (e: 'blur'): void;
};
const emit = defineEmits<Emits>();

const attrs = computed(() => {
  if (props.validation) {
    const errorMessage = getErrorMessage(props.validation);
    return {
      label:
        props.label + (props.validation.required && props.label ? ' *' : ''),
      errorMessages: errorMessage,
      error: !!errorMessage,
    };
  }

  return {
    label: props.label,
  };
});

const onBlur = () => {
  props.validation?.$touch();
  emit('blur');
};
</script>
